module.exports = __webpack_public_path__ + "static/media/num99_bg.260d7611.png";